// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-container {
  width: 100%;
  height: 16vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
}
@media screen and (max-width: 760px) {
  .nav-container {
    height: 12vh;
  }
}
.nav-container .wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  padding: 0 100px;
  max-width: 1500px;
}
@media screen and (max-width: 760px) {
  .nav-container .wrapper {
    padding: 0 60px;
  }
}
@media screen and (max-width: 500px) {
  .nav-container .wrapper {
    padding: 0 30px;
  }
}
.nav-container .wrapper .logo {
  width: 80px;
}
@media screen and (max-width: 960px) {
  .nav-container .wrapper .logo {
    width: 60px;
  }
}
.nav-container .wrapper .nav-mobile-menu {
  display: none;
}
@media screen and (max-width: 960px) {
  .nav-container .wrapper .nav-mobile-menu {
    display: block;
  }
}
.nav-container .wrapper .sidenav {
  height: 100vh;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(80, 200, 252) 100%);
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}
.nav-container .wrapper .sidenav .nav-link {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #000;
  display: block;
  transition: 0.3s;
  cursor: pointer;
}
.nav-container .wrapper .sidenav .nav-link :hover {
  background-color: red;
}
@media screen and (max-height: 450px) {
  .nav-container .wrapper .sidenav .nav-link {
    font-size: 18px;
  }
}
.nav-container .wrapper .sidenav .closebtn {
  position: absolute;
  color: #000;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
  cursor: pointer;
}
@media screen and (max-height: 450px) {
  .nav-container .wrapper .sidenav {
    padding-top: 15px;
  }
}
.nav-container .nav-menu-container {
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin: 0;
}
@media screen and (max-width: 960px) {
  .nav-container .nav-menu-container {
    display: none;
  }
}
.nav-container .nav-menu-container .nav-menu {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 40px;
}
.nav-container .nav-menu-container .nav-menu .nav-scroll-link {
  border-radius: 50px;
  background: transparent;
  white-space: nowrap;
  color: #000000;
  font-weight: bolder;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  position: relative;
}
.nav-container .nav-menu-container .nav-menu .nav-scroll-link:hover:after {
  transform: scaleX(1);
  transform-origin: left bottom left;
}
.nav-container .nav-menu-container .nav-menu .nav-scroll-link:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -5px;
  left: 0;
  background-color: #000000;
  transform-origin: left bottom right;
  transition: transform 0.25s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACJ;AACI;EARJ;IASQ,YAAA;EAEN;AACF;AADI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AAAQ;EAXJ;IAYQ,eAAA;EAGV;AACF;AADQ;EAfJ;IAgBQ,eAAA;EAIV;AACF;AAFQ;EACI,WAAA;AAIZ;AAFY;EAHJ;IAIQ,WAAA;EAKd;AACF;AAFQ;EACI,aAAA;AAIZ;AAFY;EAHJ;IAIQ,cAAA;EAKd;AACF;AAFQ;EACI,aAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,8BAAA;EACA,iFAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIZ;AAFY;EACI,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAIhB;AAFgB;EACI,qBAAA;AAIpB;AADgB;EAbJ;IAcQ,eAAA;EAIlB;AACF;AADY;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAGhB;AAAY;EAzCJ;IA0CQ,iBAAA;EAGd;AACF;AAEI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAAR;AAEQ;EAPJ;IAQQ,aAAA;EACV;AACF;AACQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AACZ;AACY;EACI,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;AAChB;AAEoB;EACI,oBAAA;EACA,kCAAA;AAAxB;AAIgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,yBAAA;EACA,mCAAA;EACA,oCAAA;AAFpB","sourcesContent":[".nav-container {\n    width: 100%;\n    height: 16vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n\n    @media screen and (max-width: 760px) {\n        height: 12vh;\n    }\n    .wrapper {\n        display: flex;\n        width: 100%;\n        height: 100%;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 100;\n        padding: 0 100px;\n        max-width: 1500px;\n\n        \n        @media screen and (max-width: 760px) {\n            padding: 0 60px;\n        }\n\n        @media screen and (max-width: 500px) {\n            padding: 0 30px;\n        }\n\n        .logo {\n            width: 80px;\n\n            @media screen and (max-width: 960px){\n                width: 60px;\n            }\n        }\n\n        .nav-mobile-menu {\n            display: none;\n\n            @media screen and (max-width: 960px) {\n                display: block;\n            }\n        }\n\n        .sidenav {\n            height: 100vh;\n            width: 0;\n            position: fixed;\n            z-index: 1;\n            top: 0;\n            right: 0;\n            background: rgb(255,255,255);\n            background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(80,200,252,1) 100%);\n            overflow-x: hidden;\n            transition: 0.5s;\n            padding-top: 60px;\n\n            .nav-link {\n                padding: 8px 8px 8px 32px;\n                text-decoration: none;\n                font-size: 25px;\n                color: #000;\n                display: block;\n                transition: 0.3s;\n                cursor: pointer;\n\n                :hover {\n                    background-color: red;\n                }\n\n                @media screen and (max-height: 450px) {\n                    font-size: 18px;\n                }\n            }\n\n            .closebtn {\n                position: absolute;\n                color: #000;\n                top: 0;\n                right: 25px;\n                font-size: 36px;\n                margin-left: 50px;\n                cursor: pointer;\n            }\n\n            @media screen and (max-height: 450px) {\n                padding-top: 15px;\n            }\n        }\n\n    }\n\n    .nav-menu-container {\n        display: flex;\n        align-items: center;\n        list-style: none;\n        text-align: center;\n        margin: 0;\n\n        @media screen and (max-width: 960px) {\n            display: none;\n        }\n\n        .nav-menu {\n            height: 50px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            padding: 0 40px;\n\n            .nav-scroll-link {\n                border-radius: 50px;\n                background: transparent;\n                white-space: nowrap;\n                color: #000000;\n                font-weight: bolder;\n                font-size: 16px;\n                outline: none;\n                border: none;\n                cursor: pointer;\n                transition: all 0.2s ease-in-out;\n                text-decoration: none;\n                position: relative;\n\n                &:hover {\n                    &:after {\n                        transform: scaleX(1);\n                        transform-origin: left bottom left;\n                    }\n                }\n\n                &:after {\n                    content: \"\";\n                    position: absolute;\n                    width: 100%;\n                    transform: scaleX(0);\n                    height: 2px;\n                    bottom: -5px;\n                    left: 0;\n                    background-color: #000000;\n                    transform-origin: left bottom right;\n                    transition: transform 0.25s ease-out;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
